import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row icon-lists feather-icons" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "flex-grow-1 align-self-center" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "icon-popup" }
const _hoisted_11 = { class: "icon-first" }
const _hoisted_12 = { class: "icon-last icon-last" }
const _hoisted_13 = { class: "form-inline" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["value"]

import { ref, defineAsyncComponent } from "vue"
import { icon_bar_status, feather_icons } from "@/composables/flagIcon"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexFeather',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const select_icon = ref({
    class: 'home',
    tag: 'home'
})

function icon_bar(icon: string) {
    select_icon.value.class = icon;
    select_icon.value.tag = '<vue-feather type="' + icon + '"></vue-feather>';

    icon_bar_status.value = true;
}
function close_icon_bar() {
    icon_bar_status.value = false;
}
function copy_icon() {
    toast.info(' Code Copied to clipboard! ', {
        hideProgressBar: true, autoClose: 2000, theme: 'colored', position: 'bottom-right',
    });
    navigator.clipboard.writeText(select_icon.value.tag);
    document.execCommand('copy');


}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Icons",
      title: "Feather Icons"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card9), {
          colClass: "col-sm-12",
          cardhaderClass: "pb-0 title-header",
          title: "Feather Icons"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feather_icons), (icon, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-sm-6 col-xl-4",
                  key: index,
                  onClick: ($event: any) => (icon_bar(icon.abbrivation))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_vue_feather, {
                      type: icon.abbrivation
                    }, null, 8, ["type"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h6", {
                        class: "mt-0",
                        textContent: _toDisplayString(icon.name)
                      }, null, 8, _hoisted_7)
                    ])
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["icon-hover-bottom p-fixed fa-fa-icon-show-div", { 'opecity-0': !_unref(icon_bar_status) }]),
      style: _normalizeStyle([_unref(icon_bar_status) ? { 'display': 'block' } : { 'display': 'none' }])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "close-icon",
              onClick: close_icon_bar
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_vue_feather, {
                class: "fa-2x",
                type: select_icon.value.class
              }, null, 8, ["type"])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-class" }, [
              _createElementVNode("label", { class: "icon-title" }, "Class"),
              _createElementVNode("span", null, "icon-drupal")
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "icon-title" }, "Markup", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("input", {
                    class: "inp-val form-control m-r-10",
                    type: "text",
                    ref: "text",
                    value: select_icon.value.tag
                  }, null, 8, _hoisted_15),
                  _createElementVNode("button", {
                    class: "btn btn-primary notification",
                    onClick: copy_icon
                  }, "Copy text")
                ])
              ])
            ])
          ])
        ])
      ])
    ], 6)
  ], 64))
}
}

})